import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useAiCopilot } from '../../../components/ai-copilot/context/use-ai-copilot';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { RecurringRevenueReportContent } from './components/RecurringRevenueReportContent';

const RecurringRevenueReportLayout: React.FC<{ reportId?: string }> = ({ reportId }) => {
  const { isOpen, drawerWidth } = useAiCopilot();

  return (
    <Box
      sx={{
        transition: (theme) =>
          theme.transitions.create('margin-right', {
            easing: isOpen ? theme.transitions.easing.easeOut : theme.transitions.easing.sharp,
            duration: isOpen
              ? theme.transitions.duration.enteringScreen
              : theme.transitions.duration.leavingScreen,
          }),
        marginRight: isOpen ? `${drawerWidth}px` : 0,
      }}
    >
      <VyLayout>
        <RecurringRevenueReportContent reportId={reportId} />
      </VyLayout>
    </Box>
  );
};

const MRR_SUGGESTIONS = [
  'Show me the MRR waterfall this month',
  "What's my current MRR and ARR?",
  'Which customers churned recently?',
  'Show MRR trend over the last 6 months',
  'Break down MRR by product',
];

const RecurringRevenueReportPage: React.FC = () => {
  const { reportId } = useParams();
  const { setSuggestions } = useAiCopilot();

  useEffect(() => {
    setSuggestions(MRR_SUGGESTIONS);
    return () => setSuggestions(undefined);
  }, [setSuggestions]);

  return (
    <>
      <Helmet>
        <title>ARR / MRR Report</title>
      </Helmet>
      <RecurringRevenueReportLayout reportId={reportId} />
    </>
  );
};

const RecurringRevenueReportPageWithSuspenseBoundary = withSuspenseBoundary(
  withGlobalSearchParams(RecurringRevenueReportPage),
);

export { RecurringRevenueReportPageWithSuspenseBoundary as RecurringRevenueReportPage };
